export default `
{{#> page user=user}}
  {{> messenger user=user}}
{{/page}}
`;
